import { useLingui } from "@lingui/react/macro";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

/**
 * The ingredient page's tabs (Pack Size & UoM design). "Inventory" has no tab
 * yet: the API has no count or receiving records to show on it.
 */
export type MaterialTab = "overview" | "uomPackSize" | "usedInRecipes";

interface MaterialTabNavProps {
  activeTab: MaterialTab;
  onTabChange: (tab: MaterialTab) => void;
}

export function MaterialTabNav({ activeTab, onTabChange }: MaterialTabNavProps) {
  const { t } = useLingui();

  const tabs: { id: MaterialTab; label: string }[] = [
    { id: "overview", label: t`Overview` },
    { id: "uomPackSize", label: t`UoM & pack size` },
    { id: "usedInRecipes", label: t`Used in recipes` },
  ];

  return (
    <div className="flex items-center gap-1 overflow-x-auto rounded-[6px] bg-(--color-surface-muted) p-1">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <Button
            key={tab.id}
            variant="ghost"
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "flex shrink-0 items-center gap-1 rounded-[6px] px-3 py-2 text-sm transition-colors whitespace-nowrap",
              isActive
                ? "bg-(--color-surface-content) font-medium text-(--color-text-primary) shadow-xs hover:bg-(--color-surface-content)"
                : "font-normal text-(--color-text-secondary) hover:text-(--color-text-primary) hover:bg-transparent",
            )}
          >
            {tab.label}
          </Button>
        );
      })}
    </div>
  );
}
